import React, { useMemo } from 'react';
import { MemoChart } from './MemoChart';
import { useThemeVersion } from '../../../useTheme';

export const buildModuleBreakdown = (attemptItems) => {
    const byModule = new Map();
    attemptItems.forEach(item => {
        const key = item.moduleName || 'Sem módulo';
        if (!byModule.has(key)) {
            byModule.set(key, { moduleName: key, correct: 0, wrong: 0, blank: 0 });
        }
        const entry = byModule.get(key);
        if (item.selectedChoiceId == null) entry.blank += 1;
        else if (item.isCorrect) entry.correct += 1;
        else entry.wrong += 1;
    });
    return Array.from(byModule.values());
};

export const ModuleBreakdownBarChart = ({ data }) => {
    const themeVersion = useThemeVersion();

    const chartData = useMemo(() => ({
        labels: (data || []).map(d => d.moduleName),
        // stack explícito (mesmo id nos 3) — o `stacked: true` da escala
        // sozinho não é suficiente pro Chart.js agrupar os datasets no
        // mesmo empilhamento; sem isso o último dataset ("Em branco") não
        // desenhava. Equivalente ao stackId="a" da versão Recharts original.
        datasets: [
            { label: 'Acertos', data: (data || []).map(d => d.correct), backgroundColor: '#22C55E', stack: 'total' },
            { label: 'Erros', data: (data || []).map(d => d.wrong), backgroundColor: '#EF4444', stack: 'total' },
            { label: 'Em branco', data: (data || []).map(d => d.blank), backgroundColor: '#9E9E9E', stack: 'total' },
        ],
    }), [data]);

    const chartOptions = useMemo(() => {
        const textColor = getComputedStyle(document.documentElement).getPropertyValue('--text-color');
        const gridColor = getComputedStyle(document.documentElement).getPropertyValue('--surface-border');
        return {
            maintainAspectRatio: false,
            indexAxis: 'y',
            layout: { padding: 12 },
            plugins: {
                legend: {
                    position: 'bottom',
                    labels: { color: textColor },
                },
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: { color: textColor, stepSize: 1, precision: 0 },
                    grid: { color: gridColor },
                },
                y: {
                    stacked: true,
                    ticks: { color: textColor },
                    grid: { color: gridColor },
                },
            },
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [themeVersion]);

    if (!data || data.length < 2) return null;

    return (
        <MemoChart type="bar" data={chartData} options={chartOptions} style={{ height: `${Math.max(160, data.length * 50)}px` }} />
    );
};
